export default __webpack_public_path__ + "4aaea616ec1bd8790629bbc0c9a70966.png";